import { defineStore } from 'pinia'
import axios from 'crypto-fetch/axios'

export const useBetInsightsStore = defineStore('betInsights', {
  state: () => ({
    insights: null
  }),
  actions: {
    async getInsights({ isHome = true, preMatch, event }) {
      const { eventId, homeTeamId, awayTeamId, scoreOfWholeMatch, playedTime } = event
      const body = {
        eventId,
        competitorId: isHome ? homeTeamId : awayTeamId
      }
      if (preMatch) body.preMatch = preMatch
      if (preMatch === 2) {
        body.forceTimeMinute = playedTime ? playedTime.split("'")[0] : ''
        body.forceTimeScore = scoreOfWholeMatch
      }

      const data = await axios.post('/facts-center/query/frontend/betting-insights/detail', body)
      // data.events = events
      this.insights = data
    }
  }
})
